import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LoginScreen from './screens/LoginScreen';
import HomeScreen from './screens/HomeScreen';
import ChatScreen from './screens/ChatScreen';
import MeditacionExpressScreen from './screens/MeditacionExpressScreen';
import MeditacionPlayerScreen from './screens/MeditacionPlayerScreen';
import EjerciciosRespiracionScreen from './screens/EjerciciosRespiracionScreen';
import ControlaEnojoScreen from './screens/ControlaEnojoScreen';
import EjercicioEnojoScreen from './screens/EjercicioEnojoScreen';
import useViewportHeight from './hooks/useViewportHeight';
import { initGA, logPageView, logEvent } from './analytics';
import { useAnalytics } from './hooks/useAnalytics';
import { useMetaPixel } from './hooks/useMetaPixel';
import DesktopBlocker from './components/DesktopBlocker';
function App() {
  const [userId, setUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Use the viewport height hook
  useViewportHeight();

  useEffect(() => {
    // Initialize Google Analytics
    initGA();

    // Verificar si hay un user_id guardado en localStorage
    const savedUserId = localStorage.getItem('user_id');
    if (savedUserId) {
      setUserId(savedUserId);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (newUserId) => {
    setUserId(newUserId);
    // Log login event
    logPageView();
  };

  const handleLogout = () => {
    // Track logout event
    logEvent('User', 'Logout', 'App');
    localStorage.removeItem('user_id');
    setUserId(null);
  };

  if (isLoading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <DesktopBlocker>
      <Router>
        <AppContent
          userId={userId}
          onLogin={handleLogin}
          onLogout={handleLogout}
        />
      </Router>
    </DesktopBlocker>
  );
}

// Componente interno que usa useAnalytics dentro del contexto del Router
function AppContent({ userId, onLogin, onLogout }) {
  // Use analytics hook to track page views
  useAnalytics();
  useMetaPixel();

  return (
    <div className="App">
      <div className="app-container">
        <Routes>
          <Route
            path="/login"
            element={
              userId ? <Navigate to="/" replace /> : <LoginScreen onLogin={onLogin} />
            }
          />
          <Route
            path="/"
            element={
              userId ? <HomeScreen userId={userId} onLogout={onLogout} /> : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/chat/:sessionId"
            element={
              userId ? <ChatScreen userId={userId} /> : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/meditacion"
            element={
              userId ? <MeditacionExpressScreen /> : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/meditacion/:meditacionId"
            element={
              userId ? <MeditacionPlayerScreen /> : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/respiracion"
            element={
              userId ? <EjerciciosRespiracionScreen /> : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/enojo"
            element={
              userId ? <ControlaEnojoScreen /> : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/ejercicio-enojo/:id"
            element={
              userId ? <EjercicioEnojoScreen /> : <Navigate to="/login" replace />
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;